import { UploadType } from '@/Types/Enums/uploadType';

export default class UploadSummaryModel {
  constructor(
    public id: string,
    public name: string,
    public type: UploadType,
    public isSelected: boolean
  ) { }
}